import { AgsSparkBehaviour } from "ags/behaviours/ags-spark-behaviour";
import { ThemeSparkComponent } from "components/theme-spark-component";
import { gameLayers } from "game-layers";

export class ThemeSparkBehaviour extends AgsSparkBehaviour {
    protected getSparkComponent() {
        const position = this.trailDisplay.getPosition();
        return new ThemeSparkComponent(this.symbol, position, gameLayers.CelebrationForeground);
    }
}
